import React from 'react';
import { Search, Star, Clock, DollarSign } from 'lucide-react';
const doctors = [{
  id: 1,
  name: 'Dr. Sarah Mitchell',
  specialty: 'Cardiologist',
  rating: 4.9,
  reviews: 248,
  experience: '12+ yrs',
  fee: 75,
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&q=80&w=300&h=300',
  available: true
}, {
  id: 2,
  name: 'Dr. James Wilson',
  specialty: 'General Practitioner',
  rating: 4.7,
  reviews: 186,
  experience: '8+ yrs',
  fee: 50,
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&q=80&w=300&h=300',
  available: true
}, {
  id: 3,
  name: 'Dr. Emily Chen',
  specialty: 'Dermatologist',
  rating: 4.8,
  reviews: 312,
  experience: '10+ yrs',
  fee: 80,
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&q=80&w=300&h=300',
  available: true
}, {
  id: 4,
  name: 'Dr. Michael Park',
  specialty: 'Neurologist',
  rating: 4.9,
  reviews: 198,
  experience: '15+ yrs',
  fee: 90,
  image: 'https://images.unsplash.com/photo-1537368910025-700350fe46c7?auto=format&fit=crop&q=80&w=300&h=300',
  available: true
}, {
  id: 5,
  name: 'Dr. Lisa Anderson',
  specialty: 'Pediatrician',
  rating: 4.8,
  reviews: 425,
  experience: '9+ yrs',
  fee: 55,
  image: 'https://images.unsplash.com/photo-1527613426441-4da17471b66d?auto=format&fit=crop&q=80&w=300&h=300',
  available: true
}, {
  id: 6,
  name: 'Dr. Robert Taylor',
  specialty: 'Orthopedist',
  rating: 4.7,
  reviews: 167,
  experience: '14+ yrs',
  fee: 85,
  image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=300&h=300',
  available: true
}];
const specialties = ['All', 'Cardiologist', 'General Practitioner', 'Dermatologist', 'Neurologist', 'Pediatrician', 'Orthopedist', 'Psychiatrist', 'Endocrinologist'];
export function Doctors() {
  return <div className="p-8 max-w-7xl mx-auto space-y-8" data-id="element-163">
      {/* Header */}
      <div data-id="element-164">
        <h1 className="text-3xl font-bold text-slate-900" data-id="element-165">Find Doctors</h1>
        <p className="text-slate-500 mt-1" data-id="element-166">
          Book appointments with top specialists
        </p>
      </div>

      {/* Search & Filter */}
      <div className="space-y-6" data-id="element-167">
        <div className="relative" data-id="element-168">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" data-id="element-169" />
          <input type="text" placeholder="Search doctors by name or specialty..." className="w-full pl-12 pr-4 py-4 bg-white border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm" data-id="element-170" />
        </div>

        <div className="flex flex-wrap gap-2" data-id="element-171">
          {specialties.map((spec, i) => <button key={spec} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${i === 0 ? 'bg-slate-800 text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 hover:border-blue-200 hover:text-blue-600'}`} data-id="element-172">
              {spec}
            </button>)}
        </div>
      </div>

      <div className="text-sm text-slate-500" data-id="element-173">6 doctors found</div>

      {/* Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-174">
        {doctors.map(doctor => <div key={doctor.id} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-md transition-shadow flex flex-col sm:flex-row gap-6" data-id="element-175">
            <div className="relative flex-shrink-0" data-id="element-176">
              <img src={doctor.image} alt={doctor.name} className="w-24 h-24 rounded-2xl object-cover bg-slate-100" data-id="element-177" />
              {doctor.available && <span className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 border-2 border-white rounded-full" data-id="element-178"></span>}
            </div>

            <div className="flex-1" data-id="element-179">
              <div className="flex justify-between items-start" data-id="element-180">
                <div data-id="element-181">
                  <h3 className="font-bold text-lg text-slate-900" data-id="element-182">
                    {doctor.name}
                  </h3>
                  <p className="text-slate-500 text-sm" data-id="element-183">{doctor.specialty}</p>
                </div>
              </div>

              <div className="flex items-center gap-4 mt-3 text-sm" data-id="element-184">
                <div className="flex items-center gap-1 text-amber-500 font-medium" data-id="element-185">
                  <Star className="w-4 h-4 fill-current" data-id="element-186" />
                  {doctor.rating}
                  <span className="text-slate-400 font-normal" data-id="element-187">
                    ({doctor.reviews})
                  </span>
                </div>
                <div className="flex items-center gap-1 text-slate-500" data-id="element-188">
                  <Clock className="w-4 h-4" data-id="element-189" />
                  {doctor.experience}
                </div>
              </div>

              <div className="mt-6 pt-4 border-t border-slate-50 flex items-center justify-between" data-id="element-190">
                <div data-id="element-191">
                  <p className="text-xs text-slate-400" data-id="element-192">Consultation Fee</p>
                  <p className="font-bold text-lg text-slate-900" data-id="element-193">
                    ${doctor.fee}
                  </p>
                </div>
                <button className="bg-slate-800 hover:bg-slate-900 text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-colors" data-id="element-194">
                  Book Now
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}